// Copyright (C) 2023 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import axios, { AxiosInstance, AxiosResponse } from "axios"


interface BaseClientConfig {
  onServiceNotAvailable?: (response: AxiosResponse) => void | Promise<void>
}


class BaseClient {
  basePath: string = "/"
  http: AxiosInstance
  params: BaseClientConfig

  constructor(params?: BaseClientConfig) {
    this.params = params || {}
    this.http = axios.create({
      baseURL: this.getBasePath(),
      validateStatus: (status) =>  {
        return ((status < 400) || [401, 422].includes(status))
      },
      withCredentials: true
    })

    this.http.interceptors.response.use(
      (response) => response,
      (error) => {
        switch (error.response.status) {
          case 503:
            if (!!params?.onServiceNotAvailable) {
              params.onServiceNotAvailable(error.response)
            }
            break
          default:
            break
        }
      }
    )
  }

  getBasePath(): string {
    return this.basePath
  }
}

export {BaseClient}